module.exports = __webpack_public_path__ + "img/kumadai.63b43ce3.jpg";